import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import style from './style.module.less';

import { emptyArray } from 'ui-components/default-props/empty';
import { getTabFilterFromPathName } from '../../../services/batch-grid-service';
import Global from '../../../store/global-selectors';
import { BatchCancelButton } from '../../../components/batches/batch-cancel-button';
import ActionsSection from '../../../components/page-layout/actions-section';
import { AssignBatchButton } from './components/assign-button';
import ArchiveBatchButton from './components/archive-button';
import PrintDocumentComponent from './print-button';

const tabToVisibleButtonsMap = {
  archived: [],
  processed: ['print', 'assign', 'archive'],
  open: ['assign', 'archive', 'cancel'],
};

const getComponet = (id, disabled) => {
  switch (id) {
    case 'print':
      return <PrintDocumentComponent />;
    case 'assign':
      return <AssignBatchButton disabled={disabled} />;
    case 'archive':
      return <ArchiveBatchButton disabled={disabled} />;
    case 'cancel':
      return <BatchCancelButton disabled={disabled} />;
    default:
      return null;
  }
};

export const BatchesListPageActions = () => {
  const selectedTab = getTabFilterFromPathName();
  const selectedBatches = useSelector(Global.selectBatchesSelectedBatches) || emptyArray;
  const disabled = selectedBatches.length === 0;
  const visibleButtons = tabToVisibleButtonsMap[selectedTab] ?? emptyArray;

  if (visibleButtons.length === 0) {
    return null;
  }

  return (
    <ActionsSection className={style['actions-section']}>
      {visibleButtons.map((id) => (
        <Fragment key={id}>{getComponet(id, disabled)}</Fragment>
      ))}
    </ActionsSection>
  );
};
